export const UNPROCESSABLE_ENTITY = 422;

export const initialState = {
  postal_code: '',
  house_number: '',
  house_number_addition: '',
  motivation_for_estimation: null,
  plans_to_move: null,
  first_name: '',
  last_name: '',
  last_name_prefix: '',
  email: '',
  phone_number: '',
};
